"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMarginAvailabilityStatus = exports.getZeroOrRounded = exports.getEffectiveAllocation = exports.getMarginAvailabilityRate = exports.getAssignedTotalLendableValue = exports.getPreAllocationMarketValue = exports.getAllocationRate = exports.getAllocatedTotalLendableValue = exports.getTotalPreAllocationLendableValue = exports.getPostAllocationLendableValue = exports.getPreAllocationLendableValue = exports.calculateMarginAvailabilityRate = exports.calculateMarginAvailability = exports.getCollateralAccountsTotalLendableValue = void 0;
const _ = __importStar(require("lodash"));
const common_1 = require("@finley-technologies/common");
const consts_1 = require("../consts");
const generateReceivableStats_1 = require("./generateReceivableStats");
const getCollateralAccountsTotalLendableValue = (collateral) => {
    return collateral.reduce((acc, c) => acc + c.preAllocationLendableValue, 0);
};
exports.getCollateralAccountsTotalLendableValue = getCollateralAccountsTotalLendableValue;
const calculateMarginAvailability = ({ collateralLendableValue, loanOutstanding, }) => collateralLendableValue - loanOutstanding;
exports.calculateMarginAvailability = calculateMarginAvailability;
const calculateMarginAvailabilityRate = ({ collateralLendableValue, loanOutstanding, }) => {
    if (loanOutstanding === 0)
        return 1;
    return common_1.utils.divideByOrZero((0, exports.calculateMarginAvailability)({ collateralLendableValue, loanOutstanding }), collateralLendableValue);
};
exports.calculateMarginAvailabilityRate = calculateMarginAvailabilityRate;
/**
 * VB wants to see lendable value prior to any allocation
 * so synthetic field added to rrt baseFields
 * (Makarand) this function is returning pre-allocatin lendable value
 * it does not take into account allocation rate.
 */
const getPreAllocationLendableValue = (receivable) => {
    return receivable.receivableReponseTapeRow.baseFields
        .pre_allocation_lendable_value;
};
exports.getPreAllocationLendableValue = getPreAllocationLendableValue;
/**
 * VB wants to see lendable value post allocation
 * so synthetic field added to rrt baseFields
 */
const getPostAllocationLendableValue = (receivable) => {
    return receivable.receivableReponseTapeRow.baseFields
        .post_allocation_lendable_value;
};
exports.getPostAllocationLendableValue = getPostAllocationLendableValue;
/**
 * `Lendable value` already takes into account `allocation rate` and `advance rate`
 * so we don't need to worry about deduping the `lendable value` (unlike `total market value`)
 * (Makarand) Comment above is incorrect. getPreAllocationLendableValue is returning pre-allocation lendable value. it does not take into account allocation rate. Given that this function is used in
 * lot of places, I have added a temp fix by dedupling receivables.
 */
const getTotalPreAllocationLendableValue = (receivables) => {
    // we should never add up pre-allocation lendable values
    // across receivables. But since this function is used in
    // multiple places, I am going to fix it by looking at
    // pre-allocation lendable value, after deduping receivables.
    const dedupedReceivables = [];
    const finleyReceivableIds = new Set();
    receivables.forEach((r) => {
        if (!finleyReceivableIds.has(r.finley_receivable_id)) {
            dedupedReceivables.push(r);
            finleyReceivableIds.add(r.finley_receivable_id);
        }
    });
    const sum = dedupedReceivables.reduce((acc, receivable) => acc + (0, exports.getPreAllocationLendableValue)(receivable), 0);
    return sum;
};
exports.getTotalPreAllocationLendableValue = getTotalPreAllocationLendableValue;
const getAllocatedTotalLendableValue = (receivables) => {
    const sum = receivables.reduce((acc, receivable) => acc + (0, exports.getPostAllocationLendableValue)(receivable), 0);
    return sum;
};
exports.getAllocatedTotalLendableValue = getAllocatedTotalLendableValue;
/**
 * Allocation is the portion of the `CollateralAccount` (that the `Receivable` input belongs to) that has been allocated to a `LoanAccount`
 *
 * Receivables show up in the `ReceivableResponseTape` multiple times if they are cross collateralized across multiple `LoanAccounts`
 *
 * `Allocation` across all records with the same `finley_receivable_id` should sum to 1
 */
const getAllocationRate = (receivable) => receivable.receivableReponseTapeRow.valuationFields.valuationRate;
exports.getAllocationRate = getAllocationRate;
/**
 * `Pre-Allocation Market Value` of a receivable is the raw market value (`exposure`) of the receivable
 * prior to applying any `allocation rate` or `advance rate`
 *
 * `Exposure`/`Pre-Allocation Market Value` across all records with the same `finley_receivable_id` will be equal
 */
const getPreAllocationMarketValue = (receivable) => receivable.receivableReponseTapeRow.requiredIntermediateFields.exposure;
exports.getPreAllocationMarketValue = getPreAllocationMarketValue;
/**
 * Top level collateral account stats on a loan account are derrived off of the whole list of receivables
 * But the list of receivables for a loanAccount.collateralAccounts[number].receivables is just
 * a list of assigned receivables
 *
 * For margin availability we only want to consider the assigned lendable value, not the aggregate of the
 * the collteral accounts lendable value.
 */
const getAssignedTotalLendableValue = (loanAccount) => {
    const { totalPreAllocationLendableValue } = (0, generateReceivableStats_1.generateReceivableStats)(loanAccount.collateralAccounts.flatMap((ca) => ca.receivables));
    return totalPreAllocationLendableValue;
};
exports.getAssignedTotalLendableValue = getAssignedTotalLendableValue;
const getMarginAvailabilityRate = (loanAccount) => {
    const collateralLendableValue = (0, exports.getAssignedTotalLendableValue)(loanAccount);
    const loanOutstanding = loanAccount.principalBalance;
    return (0, exports.calculateMarginAvailabilityRate)({
        collateralLendableValue,
        loanOutstanding,
    });
};
exports.getMarginAvailabilityRate = getMarginAvailabilityRate;
/**
 * Calculates the weighted average allocation of the receivables
 * weighted by exposure (market value)
 */
const getEffectiveAllocation = (receivables) => {
    const { totalMarketValue } = (0, generateReceivableStats_1.generateReceivableStats)(receivables);
    const weightedAverageNumerator = receivables.reduce((acc, receivable) => {
        const allocation = receivable.receivableReponseTapeRow.valuationFields.valuationRate;
        const marketValue = (0, exports.getPreAllocationMarketValue)(receivable);
        const delta = allocation * marketValue;
        return acc + delta;
    }, 0);
    return common_1.utils.divideByOrZero(weightedAverageNumerator, totalMarketValue);
};
exports.getEffectiveAllocation = getEffectiveAllocation;
/**
 * Calculates if the absolute value of a number is rounded to 0
 *
 * Used for determining if a negative margin availability / margin availability rate is 0 due to rounding displayed
 */
const getZeroOrRounded = (num) => {
    const toFixedValue = _.round(Math.abs(num), 6).toFixed(6);
    const isZero = toFixedValue === '0.000000';
    return {
        roundedValue: isZero ? 0 : Math.round(num),
        isZero,
    };
};
exports.getZeroOrRounded = getZeroOrRounded;
const getMarginAvailabilityStatus = ({ loanOutstanding, collateralLendableValue, marginAvailabilityRate, }) => {
    const { isZero: roundedMarginAvailabilityRateIsZero } = (0, exports.getZeroOrRounded)(marginAvailabilityRate * 100);
    if ((marginAvailabilityRate < 0 && !roundedMarginAvailabilityRateIsZero) ||
        // differentiates between 0 margin availability rate due to collateral lendable value = loan outstanding vs divide by zero collateral lendable value
        (loanOutstanding > 0 && collateralLendableValue === 0)) {
        return 'underMargin';
    }
    if (roundedMarginAvailabilityRateIsZero ||
        (marginAvailabilityRate >= 0 &&
            marginAvailabilityRate <= consts_1.NEAR_MARGIN_STATUS_THRESHOLD)) {
        return 'nearMargin';
    }
    return 'excessMargin';
};
exports.getMarginAvailabilityStatus = getMarginAvailabilityStatus;
//# sourceMappingURL=utils.js.map